import script from "./ResolveUrlList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResolveUrlList.vue?vue&type=script&lang=ts&setup=true"

import "./ResolveUrlList.vue?vue&type=style&index=0&id=46f62bea&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f62bea"]])

export default __exports__